export default __webpack_public_path__ + "static/media/mobileWef2.f198d3ca.png";